import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, BootstrapVueIcons, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import AOS from "aos";
import "aos/dist/aos.css";
import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);


Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(IconsPlugin);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  mounted() {
		AOS.init();
	},
}).$mount('#app')
